


































































































































































































































































































































































































































































































import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { Component } from 'vue-mixin-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamTwitter from '@/components/ExamTwitter.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import * as StringUtil from '@/common/StringUtil';

import * as DesignCode from '@/classification/DesignCode';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import DesignResource from '@/models/exam/DesignResource';
import News from '@/models/exam/News';
import BenefitsResource from '@/models/exam/BenefitsResource';
import Rank from '@/models/rank/Rank';

Vue.use(VueScrollTo, {
  duration: 500,
  easing: 'ease-in-out',
});

@Component(
  {
    components: {
      'e-twitter': ExamTwitter,
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class Top extends BaseView {
  private isIndicatorDisplay = false;

  private ExamRepository = RepositoryFactory.get().exam;

  private RankRepository = RepositoryFactory.get().rank;

  private examInfo: ExamInfo = new ExamInfo();

  private news: News[] = [];

  private benefits: BenefitsResource[] = [];

  private startingRanks: Rank[] = [];

  private acceptingRanks: Rank[] = [];

  private stringUtils = StringUtil;

  private resources = {
    TOP_MV_PIC: new DesignResource(),
    TOP_MV_PIC_SP: new DesignResource(),
    TOP_MV_LOGO: new DesignResource(),
    TOP_MV_BG: new DesignResource(),
    TOP_MV_TITLE: new DesignResource(),
    TOP_MV_SUB_TITLE: new DesignResource(),
    TOP_MV_TITLE_TERM: new DesignResource(),
    NEWS_ICON: new DesignResource(),
    NEWS_ROW_HEAD_ICON: new DesignResource(),
    NEWS_MAIN_COLOR: new DesignResource(),
    NEWS_SUB_TITLE_COLOR: new DesignResource(),
    ENTRY_ICON: new DesignResource(),
    TOP_ENTRY_BG: new DesignResource(),
    TOP_ENTRY_MAIN_COLOR: new DesignResource(),
    TOP_ENTRY_SUB_TITLE_COLOR: new DesignResource(),
    ABOUT_ICON: new DesignResource(),
    ABOUT_MAIN_COLOR: new DesignResource(),
    ABOUT_SUB_TITLE_COLOR: new DesignResource(),
    BENEFITS_ICON: new DesignResource(),
    RANK_BENEFIT_THUMBNAIL: new DesignResource(),
    TOP_BENEFITS_BG: new DesignResource(),
    TOP_BENEFITS_MAIN_COLOR: new DesignResource(),
    TOP_BENEFITS_SUB_TITLE_COLOR: new DesignResource(),
    BENEFITS_BADGE_ALL: new DesignResource(),
    BENEFITS_BADGE_PASS: new DesignResource(),
    BENEFITS_BADGE_PERFECT: new DesignResource(),
    TOP_OUTLINE_ICON: new DesignResource(),
    TOP_OUTLINE_MAIN_COLOR: new DesignResource(),
    TOP_OUTLINE_SUB_TITLE_COLOR: new DesignResource(),
    TOP_STEP_ICON: new DesignResource(),
    TOP_STEP_BG: new DesignResource(),
    TOP_STEP_MAIN_COLOR: new DesignResource(),
    TOP_STEP_SUB_TITLE_COLOR: new DesignResource(),
    EXAM_RANK_ICON: new DesignResource(),
    TWITTER_IMG: new DesignResource(),
    OFFICIAL_TWITTER: new DesignResource(),
    OFFICIAL_INSTAGRAM: new DesignResource(),
    OFFICIAL_FACEBOOK: new DesignResource(),
    GOODS_APPEAL_IMG: new DesignResource(),
  };

  private async mounted() {
    this.isIndicatorDisplay = true;

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const TopCss = document.createElement('link');
    TopCss.rel = 'stylesheet';
    TopCss.href = '/css/top.css';
    this.$el.appendChild(TopCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const commonJs = document.createElement('script');
    commonJs.src = '/js/common.js';

    const topJs = document.createElement('script');
    topJs.src = '/js/index.js';

    const browserSelector = document.createElement('script');
    browserSelector.src = '/js/css_browser_selector.js';
    this.$el.appendChild(browserSelector);

    try {
      // 検定情報を取得する
      this.getExamInfo();

      // 検定ランクを取得する
      await this.getExamRankInfo();
    } catch (_) {
      // do nothing
    }

    // 他画面から遷移してきた場合のアンカーリンク用スクロール
    const anchor = this.$route.hash;
    if (anchor && anchor.match(/^#.+$/)) {
      setTimeout(() => {
        this.$scrollTo(anchor);
      }, 500);
    }

    this.$el.appendChild(commonJs);
    this.$el.appendChild(topJs);
    this.isIndicatorDisplay = false;
  }

  /**
   * 検定情報を取得する
   */
  private getExamInfo() {
    if (this.storedExam !== null) {
      this.bindExamInfo(this.storedExam);
    } else {
      this.ExamRepository.getExam().then((response: any) => {
        if (response.status === 200) {
          this.bindExamInfo(response.data);
        }
      });
    }
  }

  /**
   * 検定情報のセット処理
   * @param exam 検定情報
   */
  private bindExamInfo(exam: any) {
    this.examInfo.examTitle = exam.exam_title;
    const overview = MarkdownToHTML(exam.overview);
    this.examInfo.overview = overview;

    const about = MarkdownToHTML(exam.about);
    this.examInfo.about = about;

    // 特典
    if (exam.benefits_resources !== undefined) {
      exam.benefits_resources.forEach((benefit: any) => {
        const benefitObj = new BenefitsResource();
        benefitObj.benefitsType = benefit.benefits_type;
        benefitObj.thumbnail = benefit.thumbnail;
        benefitObj.order = benefit.order;
        benefitObj.name = benefit.name;
        benefitObj.explanation = MarkdownToHTML(benefit.explanation);
        benefitObj.notes = MarkdownToHTML(benefit.notes);
        this.benefits.push(benefitObj);
      });
    }

    // お知らせ
    if (exam.news !== undefined) {
      exam.news.forEach((news: any) => {
        const newsObj = new News();
        newsObj.date = news.date;
        newsObj.text = MarkdownToHTML(news.text);
        this.news.push(newsObj);
      });
    }

    // デザインリソース
    if (exam.resources !== undefined) {
      exam.resources.forEach((resource: any) => {
        const key = resource.display_place_key;
        if (key in this.resources) {
          const tmp = new DesignResource();
          tmp.displayPlaceKey = resource.display_place_key;
          tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
          tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
          tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
          tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
          tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.resources[key] = tmp;
        }
      });
    }
  }

  /**
   * 検定ランク情報を取得する
   */
  private async getExamRankInfo() {
    await this.RankRepository.getRanks().then((response: any) => {
      if (response.status === 200
        && response.data.exam_ranks !== undefined) {
        response.data.exam_ranks.forEach((rank: any) => {
          const rankObj = new Rank();
          rankObj.rankCode = StringUtil.encodeToBase64Url(rank.exam_rank_code);
          rankObj.title = rank.exam_rank_title;
          if (rank.exam_fee_type === 'pay') {
            rankObj.fee = StringUtil.separateNumber(rank.fees[0].fee);
          }
          rankObj.paymentType = rank.exam_fee_type;
          rankObj.requestPeriodEnd = StringUtil.isEmpty(rank.request_period_end) ? '' : StringUtil.toJapanDateString(rank.request_period_end, 'MM/DD');

          // eslint-disable-next-line prefer-destructuring
          const resources = rank.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                rankObj.thumbnail = resource.resource_uri;
                rankObj.alternativeText = resource.alternative_text;
              }
            });
          }

          if (rank.is_starting) {
            this.startingRanks.push(rankObj);
          }
          if (rank.is_accepting) {
            this.acceptingRanks.push(rankObj);
          }
        });
      }
    });
  }

  private scrollToAnchor(anchor: string) {
    this.$scrollTo(anchor);
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   */
  private transitionExamDetail(rankCode: string) {
    this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${rankCode}`);
  }
}
